(() => {
  const selector = '.sp-scroll-reveal:not([data-sp-reveal-ready])';
  let observer;

  const reveal = (element) => {
    element.classList.add('sp-scroll-reveal--visible');
    observer?.unobserve(element);
  };

  const getObserver = () => {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -6% 0px'
      }
    );

    return observer;
  };

  const initialize = (scope = document) => {
    const elements = [];

    if (scope.matches?.(selector)) elements.push(scope);
    elements.push(...scope.querySelectorAll(selector));

    elements.forEach((element) => {
      element.dataset.spRevealReady = 'true';

      element.querySelectorAll('[data-sp-reveal-item]').forEach((item, index) => {
        item.style.setProperty('--sp-reveal-delay', `${Math.min(index, 5) * 90}ms`);
      });

      const currentObserver = getObserver();
      if (currentObserver) {
        currentObserver.observe(element);
      } else {
        reveal(element);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
